module.exports = __webpack_public_path__ + "img/ajuan_lembur.5b59de6c.png";